import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes2";
import useTable from "../../components/useTable";
import { Dimmer } from "../../components/spinner";
import { ModalAsientoContable } from "./modalAsientoContable";
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

const TablaAsientoNueva = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const txtId = useRef();
  const txtDescripcion = useRef();
  const cmbTipo = useRef();
  const txtDeducible = useRef();
  const chkPorcen = useRef();
  const chkMilPorcen = useRef();
  const chkUniTri = useRef();
  const chkMontFij = useRef();
  const chkOtroPor = useRef();
  const txtOtroPorcen = useRef();
  const txtIdProve = useRef();
  const txtIdCuenta = useRef();
  const txtCuentaCont = useRef();
  const txtIdCuenta2 = useRef();
  const txtCuentaCont2 = useRef();
  const txtBuscador = useRef();

  const [operacion, setOperacion] = useState(0);
  const [mostrar, setMostrar] = useState(false);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [visibleOtro, setVisibleOtro] = useState("collapse");
  const [visibleISLR, setVisibleISLR] = useState("hidden");
  const [tituloHeader] = useState("Gestionar Asientos Contables.");
  const [records, setRecords] = useState([]);
  const [idAsiento, setIdAsiento] = useState();
  const [detalle, setDetalle] = useState([]);

  const [habilitado, setHabilitado] = useState(true);
  const [catalogoCuentaRe, setCatalogoCuentaRe] = useState(false);
  const [catalogoTipoReten, setCatalogoTipoReten] = useState(false);
  const [tercero, setTercero] = useState({
    idagente: "",
    nombre: "",
  });

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);

  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true,
  });

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "COD.",
      textAlign: "center",
    },
    {
      id: "descripcion",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              (x.idasiento !== null ? x.idasiento.includes(target.value) : "") ||
              (x.descripcion !== null
                ? x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                : "")
            ) {
              return x;
            }
          });
      },
    });
  };

  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);

  const blanquear = () => {
    setOperacion("");
    txtIdCuenta.current.value = "";
    txtIdCuenta2.current.value = "";
    txtCuentaCont.current.value = "";
    txtCuentaCont2.current.value = "";
    txtIdProve.current.value = "";
    setTercero({
      idagente: "",
      nombre: "",
    });
    chkPorcen.current.checked = false;
    chkMilPorcen.current.checked = false;
    chkUniTri.current.checked = false;
    chkMontFij.current.checked = false;
    chkOtroPor.current.checked = false;
    txtDeducible.current.value = "";
    txtOtroPorcen.current.value = "";
    setVisibleISLR("hidden");
    setVisibleOtro("collapse");
    setVisibleBtn("visible");

    setValues({
      idtiporetencion: "",
      descripcion: "",
      unidad: "",
      idcuentacontable: "",
      tipo: "",
      deducible: "",
      otro: "",
      idagente: "",
    });
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true,
    });
    cmbTipo.current.value = "";
    txtId.current.value = "";
    txtDescripcion.current.value = "";
    setActivate(false);
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/contabilidad/actualizarasiento`;
    let body;
    body = {
      operacion: ope,
      idasi: txtId.current.value !== "" ? txtId.current.value : 0,
      descri: txtDescripcion.current.value.toUpperCase().trim(),
      idorden: 0,
      idefi: parseInt(idefiscal),
      rever: 0,
      idasireve: 0,
      llamado: 0,
      asientos: records,
      operasiento: 1,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }

          blanquear();

          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "ubicacion_key"'
          ) {
            mensaje = "Ya existe un Registro";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = "";
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === "0") {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }
  
  const seleccionarDetalleAsiento = (id) => {
    setCatalogoCuentaRe(false);
    let campos = "*";
    let nomtab = "asientodetalle";
    let nomid = "idasiento";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setDetalle(response.data);
          setMostrar(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
      });
  };

  const seleccionarAsiento = (id) => {
    let campos = "*";
    let nomtab = "asiento";
    let nomid = "idasiento";
    let nomid2 = "idefiscal";
    let id2 = idefiscal;

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id=${id}&id2=${id2}`;

    console.log(endpoint);

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          console.log(response.data);
          setAsiento(response.data[0]);
          seleccionarDetalleAsiento(response.data[0].idasiento);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistros = () => {

    let campos = 'idasiento,descripcion';
    let nomtab = 'asiento';
    let condi = 'idefiscal = ' + parseInt(idefiscal);
    let orden = 'idasiento';

    let endpoint  = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
          console.log(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const cerrar = () => {
    props.setTabla(0);
  };

  const gestionarAsientoContable = (op, id) => (e) => {
    e.preventDefault();
    setOperacion(op);
    if (op === 1) {
      setMostrar(true);
    } else {
      setIdAsiento(id);
      setMostrar(true);
      //seleccionarAsiento(id);
    }      
    
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3 className="fw-bold m-0">{tituloHeader}</h3>
        <a type="button" onClick={cerrar} className="text-light fw-bold">
            Salir<i className="fas fa-times ms-2"></i>
        </a>
        </header>

        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
            <SearchInput
            onChange={handleSearch}
            placeholder="Buscar"
            ref={txtBuscador}
            />
        </div>
            <div className="col-auto m-0 p-0">
            <PrimaryButton icon = 'fa-plus m-0'
                onClick={gestionarAsientoContable(1, "")}
            >
            </PrimaryButton>
            </div>
        </div>
        <div className="col-12 m-0 p-0">
        <TblContainer>
            <TblHead />
            <tbody>
            {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                    <td
                    className="align-baseline"
                    style={{
                        textAlign: "center",
                        alignItems: "center",
                        width: "50px",
                    }}
                    >
                    {item.idasiento}
                    </td>

                    <td
                    className="align-baseline"
                    style={{
                        textAlign: "center",
                        alignItems: "center",
                        width: "300px",
                    }}
                    >
                    {item.descripcion}
                    </td>

                    <td
                    className="align-baseline"
                    style={{
                        textAlign: "center",
                        alignItems: "center",
                        width: "120px",
                    }}
                    >
                    <button
                        onClick={gestionarAsientoContable(
                        4,
                        item.idasiento
                        )}
                        className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                        <i className="fas fa-eye"></i>{" "}
                    </button>
                    <button
                        onClick={gestionarAsientoContable(
                        2,
                        item.idasiento
                        )}
                        className="btn btn-sm mx-1 btn-warning rounded-circle"
                    >
                        <i className="fa fa-edit"></i>{" "}
                    </button>
                    <button
                        onClick={gestionarAsientoContable(
                        3,
                        item.idasiento
                        )}
                        className="btn btn-sm mx-1 btn-danger rounded-circle"
                    >
                        <i className="fa fa-trash"></i>{" "}
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
        </TblContainer>
        <TblPagination />
        </div>

      <ModalAsientoContable
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
          setIdAsiento(0);
        }}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
        idasiento={idAsiento}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaAsientoNueva;
